var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1161_11778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7531 23.3387H12.3953C12.022 23.3387 11.7458 23.1716 11.567 22.8373C11.3881 22.503 11.4118 22.1781 11.638 21.8626L20.9888 8.34344C21.144 8.13138 21.3395 7.98613 21.5755 7.90768C21.8114 7.82924 22.051 7.83918 22.2943 7.93752C22.5377 8.0302 22.7243 8.18823 22.8542 8.41162C22.9841 8.63499 23.0311 8.87037 22.9953 9.11777L21.8824 18.0174H27.1833C27.5935 18.0174 27.8802 18.1968 28.0435 18.5555C28.2069 18.9142 28.1598 19.2514 27.9022 19.5669L17.5896 31.9339C17.4233 32.128 17.2201 32.2546 16.9801 32.3136C16.74 32.3726 16.5117 32.3488 16.2951 32.2422C16.0728 32.1413 15.9007 31.986 15.7787 31.7763C15.6568 31.5667 15.6109 31.3347 15.641 31.0803L16.7531 23.3387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1161_11778",
    x: 6.64849,
    y: 3.05547,
    width: 26.2902,
    height: 34.0902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_11778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_11778",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningSelected);
export default __webpack_public_path__ + "static/media/lightning-selected.aebe9f9d856dee98b28be9f2ceabbc3e.svg";
export { ForwardRef as ReactComponent };